import {
  DTNode,
  DTScheduleNode,
  ScheduleNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {ServerNode} from 'common/src/modules/nodes/nodes.types';
import {trimDescription} from 'common/src/modules/campaignVersions/utils/trimDescription';

export function serializeScheduleNode(node: DTNode, newNode: ServerNode) {
  const scheduleNode = node as DTScheduleNode;

  return {
    ...newNode,
    description: trimDescription(newNode.description),
    scheduleType: scheduleNode.scheduleType,
    timezoneSource: scheduleNode.timezoneSource,
    timeZone: scheduleNode.timeZone,
    ...(scheduleNode.randomizeOutputs && {randomizeOutputs: true}),
    outputs: (node.outputs as ScheduleNodeOutputData[]).map((output) => {
      return {
        nodeId: output.nodeId,
        id: output.id,
        dateRange: output.dateRange,
        daysOfWeek: output.daysOfWeek,
        type: output.type,
        name: output.name,
      };
    }),
  };
}
